import { motion } from "framer-motion";
import type { ReactNode } from "react";

export const ZoomIn = ({
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  return (
    <motion.div
      initial={{ scale: 0.5 }}
      whileInView={{ scale: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.2 }}
    >
      {children}
    </motion.div>
  );
};
